import React from "react";
import SideMenuLink from "./SideMenuLink/SideMenuLink";
import { Link } from "react-router-dom";
import settings_icon from "../../img/settings-24px.svg";
import payment_icon from "../../img/payment-24px.svg";
import reports_icon from "../../img/trending_up-24px.svg";
import home from "../../img/home-24px.svg";
import power_off_icon from "../../img/power_settings_new-24px.svg";
//

//
export default class SideMenu extends React.Component {
  state = {
    title: "Kakeibo",
    links: [
      { title: "Dashboard", url: "/dashboard", icon: home },
      { title: "Budget", url: "/budget/expenses", icon: payment_icon },
      { title: "Reports", url: "/reports", icon: reports_icon },
      { title: "Settings", url: "/settings", icon: settings_icon },
    ],
    extra_links: [
      { title: "logout", url: "/home", icon: power_off_icon, logout: true },
    ],
    selected_link: "",
  };

  getSelectedFromPath = (pathname) => {
    if (!pathname) return "";
    if (pathname.startsWith("/settings")) return "Settings";
    if (pathname.startsWith("/reports")) return "Reports";
    if (pathname.startsWith("/budget")) return "Budget";
    if (pathname.startsWith("/dashboard")) return "Dashboard";
    return "";
  };

  render() {
    let style = {};

    if (this.props.height !== undefined)
      style.height = this.props.height + "px";
    const collapsed = this.props.collapsed;
    const selected = this.props.currentPath
      ? this.getSelectedFromPath(this.props.currentPath)
      : this.state.selected_link;
    
    return (
      <div className="h-full" style={style}>
        <div className="flex h-full flex-col">
          <nav className="flex-1 space-y-1 px-3 pt-4">
            {this.state.links.map((link, key) => (
              <div key={key}>
                <Link to={link.url}>
                  <SideMenuLink
                    title={link.title}
                    icon={link.icon}
                    collapsed={collapsed}
                    selected={selected}
                    onClick={this.onClickHandler}
                  ></SideMenuLink>
                </Link>
              </div>
            ))}
          </nav>
          <div className="border-t border-slate-200 px-3 py-3">
            {this.state.extra_links.map((link, key) => (
              <div key={key}>
                <Link to={link.url}>
                  <SideMenuLink
                    title={link.title}
                    icon={link.icon}
                    collapsed={collapsed}
                    selected={selected}
                    onClick={this.onClickHandler}
                    logout={link.logout}
                    onLogOut={this.props.onLogOutHandler}
                  ></SideMenuLink>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  onClickHandler = (type) => {
    if (type === "logout") {
      type = "";
    }
    this.setState({
      selected_link: type,
    });
    this.props.OnSelectMenu();
  };
}
